import React from "react";
import { useSelector } from "react-redux";
import ProductCard from "./ProductCard";
import "./style.css";
import AlertModal from "../../AlertModal";
import AddMyAnalogModal from "../../AddMyAnalogModal";
import NoData from "../Data/NoData";
import localization from "../../../data/config";

const { numberOfParts } = localization;

/**
 * @name List
 * @function
 * @description Container to Display the Title and Product Cards in Mobile
 * @returns {JSX}
 * @param {*} props
 */
const List = () => {
  const data = useSelector((state) => ({
    totalCount: state.parts.allData,
    parts: state.parts.data,
    noResultsLabel: state.labels.noResults,
    count: state.parts.count,
    label: state.labels.parts,
    parameters: state.filters.parameters,
  }));
 
  const count = data.count === data.totalCount.length ? data.count : numberOfParts.replace( '{part}', data.count ).replace( '{whole}', data.totalCount.length )

  return (
    <div className="product__cards__container">
      <div className="cards__header">
        <div className="cards__header__text">{data.label}</div>
        <div className="cards__header__count">{count}</div>
      </div>
      {data.parts.length > 0 ? (
        data.parts.map((part, index) => (
          <ProductCard
            key={`part-${index}`}
            partData={part}
            parameters={data.parameters}
          />
        ))
      ) : (<NoData />)}
      <AlertModal mobile/>
      <AddMyAnalogModal mobile/>
    </div>
  );
};

export default List;
